import { currentLang, pick } from "@kit/lang";

/** Player-facing UI copy, TR/EN. The hidden word follows the same language (shared lexicons in src/shared). */
const STRINGS = {
  title: { tr: "Kaçış", en: "Escape" },
  moves: { tr: "Hamle", en: "Moves" },
  left: { tr: "kalan", en: "left" },
  scrambled: { tr: "Karışık harfler", en: "Scrambled letters" },
  word: { tr: "Kelime", en: "Word" },
  wordLen: { tr: "Kelime · {n} harf", en: "Word · {n} letters" },
  wordStar: { tr: "★ Kelime!", en: "★ Word!" },
  otherOrder: { tr: "Sıra farklı çıktı", en: "Order was different" },
  tipDrag: { tr: "Solucanı baş ya da kuyruğundan sürükle · aynı renkli kapıdan çıkar", en: "Drag a worm by its head or tail · out the same-color door" },
  tipWord: { tr: "Harfleri doğru sırayla çıkarırsan gizli kelime ★ kazandırır", en: "Escape in the right order to spell the hidden word ★" },
  tipStone: { tr: "Numaralı taş, o kadar solucan kaçınca erir", en: "A numbered stone melts once that many worms escape" },
  restart: { tr: "↻ Yeniden", en: "↻ Restart" },
  skip: { tr: "Atla ›", en: "Skip ›" },
  otherColor: { tr: "başka renk", en: "wrong color" },
  wonStar: { tr: "★ Kelimeyi buldun!", en: "★ Found the word!" },
  wonAll: { tr: "Hepsi kaçtı!", en: "All out!" },
  escaped: { tr: "{jellies} jöle {moves} hamlede kaçtı", en: "{jellies} jellies escaped in {moves} moves" },
  starWord: { tr: "★ Kelime: {word} · {award}", en: "★ Word: {word} · {award}" },
  starNew: { tr: "+1 yıldız", en: "+1 star" },
  starOld: { tr: "yıldız daha önce kazanıldı", en: "star already earned" },
  missedWord: { tr: "Gizli kelime {word} idi — sırayı tutturunca ★ gelir", en: "The hidden word was {word} — match its order for ★" },
  share: { tr: "Paylaş", en: "Share" },
  retry: { tr: "Yeniden", en: "Retry" },
  lost: { tr: "Hamle bitti", en: "Out of moves" },
  lostSkip: { tr: "Takıldıysan bu bölümü ücretsiz atlayabilirsin.", en: "Stuck? You can skip this level for free." },
  lostRetry: { tr: "Yeniden dene — her zaman ücretsiz.", en: "Try again — it's always free." },
  shareStar: {
    tr: "Kaçış {n}. bölüm: {jellies} jöleyi {moves} hamlede kaçırdım ve gizli kelimeyi buldum ★",
    en: "Escape level {n}: I got {jellies} jellies out in {moves} moves and found the hidden word ★",
  },
  shareNoStar: {
    tr: "Kaçış {n}. bölüm: {jellies} jöleyi {moves} hamlede kaçırdım. Gizli kelimeyi sen bulabilir misin?",
    en: "Escape level {n}: I got {jellies} jellies out in {moves} moves. Can you find the hidden word?",
  },
  cardLevel: { tr: "{n}. bölüm", en: "Level {n}" },
  cardWord: { tr: "★ Kelime", en: "★ Word" },
  cardMoves: { tr: "{moves} hamle", en: "{moves} moves" },
  cardInMoves: { tr: "{moves} hamlede", en: "in {moves} moves" },
  cardAsk: { tr: "Gizli kelimeyi bulabilir misin?", en: "Can you find the hidden word?" },
  cardFair: { tr: "Bekleten reklam yok · Can yok", en: "No waiting ads · No lives" },
  /** Screen-reader instructions for the canvas (TR = the page's meta description). */
  instructions: {
    tr: "Jöle solucanları aynı renkli kapıdan kaçır; harfler doğru sırayla çıkarsa gizli Türkçe kelimeyi bulursun.",
    en: "Guide the jelly worms out through the same-color doors; escape them in the right order to spell the hidden word.",
  },
} as const;

export type Key = keyof typeof STRINGS;
export function t(key: Key, vars: Record<string, string | number> = {}): string {
  return pick(currentLang(), STRINGS[key]).replace(/\{(\w+)\}/g, (_m, k: string) => String(vars[k] ?? ""));
}
